import * as React from "react";
import styled from "styled-components";
import { tomowelLogo } from "../model/DataConst";
import { CSSProperties } from "react";
import { device } from "../model/Const";
import { useMediaQuery } from "@material-ui/core";

const FooterAnchor = styled.a`
    cursor: pointer;
    text-decoration: none;
    color: #694e39;
`;

const FooterAnchorSpan = styled.p`
	border-left: 2px solid rgb(223, 0, 58);
	padding-left: 4px;
	font-size: 1rem;
	
    @media ${device.mobileS} {
		font-size: 0.6rem;
    }
    
    @media ${device.mobileM} {
		font-size: 0.6rem;
    }
    
    @media ${device.mobileL} {
		font-size: 0.7rem;
    }
    
    @media ${device.tablet} {
		font-size: 0.8rem;
    }
`;

const CopyRightDiv = styled.small`
	width: 100%;
	bottom: 1%;
	font-size: 1rem;
	
    @media ${device.mobileS} {
		font-size: 0.6rem;
    }
    @media ${device.mobileM} {
		font-size: 0.6rem;
    }
    @media ${device.mobileL} {
		font-size: 0.6rem;
    }
    @media ${device.tablet} {
		font-size: 0.8rem;
    }
`;

const Footer = React.memo( ( props: {
	style?: CSSProperties
} ) => {
	// 紹介画像を縦スクロールタイプにするかどうかの判定用メディアクエリ
	const isSmallMedia = useMediaQuery( "(max-width: 500px) and (orientation: portrait)" );

	// メディアクエリの変更時に呼ばれる
	const style = React.useMemo( () => {
		if ( isSmallMedia ) {
			return {
				parent: {
					flexDirection: "column"
				} as CSSProperties,
				anchor: {
					justifyContent: "center"
				},
				img: {
					height: "30px"
				},
				span: {
					marginBlockEnd: 0
				}
			}
		}

		return {
			parent: {} as CSSProperties,
			anchor: {
				justifyContent: "flex-end"
			},
			img: {
				width: "70%"
			},
			span: undefined
		};
	}, [isSmallMedia] );

	return (
		<>
			<div style={{
				width: "100%",
				borderTop: "4px black solid",
				position: "relative"
			}}/>
			<footer style={{
				height: "10%",
				width: "100%",
				backgroundColor: "white",
				position: "relative",
				textAlign: "center",
				...props.style,
			}}>
				<div style={{
					display: "flex",
					justifyContent: "space-around",
					...style.parent
				}}>
					<div style={{
						width: isSmallMedia ? "100%" : "50%",
						display: "flex",
						alignItems: "center",
						justifyContent: "space-around"
					}}>
						<FooterAnchor target="_blank" rel="noopener noreferrer"
									  href="https://www.kyodoprinting.co.jp/company-profile/org.html">
							<FooterAnchorSpan style={style.span}>会社概要</FooterAnchorSpan>
						</FooterAnchor>
						<FooterAnchor target="_blank" rel="noopener noreferrer"
									  href="https://www.kyodoprinting.co.jp/agreement.html">
							<FooterAnchorSpan style={style.span}>当サイトのご利用について</FooterAnchorSpan>
						</FooterAnchor>
					</div>
					<div style={{
						width: isSmallMedia ? "100%" : "50%",
						height: "60%",
						display: "flex",
						alignItems: "center",
						justifyContent: "flex-end"
					}}>
						<FooterAnchor target="_blank"
									  rel="noopener noreferrer"
									  href="https://www.kyodoprinting.co.jp/"
									  style={{
										  width: "100%",
										  display: "flex",
										  ...style.anchor
									  }}>
							<img src={tomowelLogo} alt={"Tomowelへのリンク"} style={style.img}/>
						</FooterAnchor>
					</div>
				</div>
				<CopyRightDiv>
					© 2020 Kyodo Printing Co., Ltd.
				</CopyRightDiv>
			</footer>

		</>
	);
} );

export default Footer;